(() => {
  'use strict';

  const dataNode = document.getElementById('clc-cbd-commerce');
  if (!dataNode) return;

  const data = JSON.parse(dataNode.textContent);
  const state = {
    mode: 'subscription',
    weeks: '4',
    variantId: String(data.selectedVariantId),
    busy: false,
    uncertain: false
  };
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const money = (cents, currency = data.currency) => new Intl.NumberFormat(data.locale || 'en-US', {
    style: 'currency',
    currency
  }).format(cents / 100);
  const variant = () => data.variants.find(item => String(item.id) === state.variantId);
  const planWeeks = plan => {
    const match = String(plan.name || '').toLowerCase().match(/\b(4|6|8)\s*(?:week|wk)/);
    return match ? match[1] : null;
  };
  const allocation = (weeks = state.weeks) => variant()?.allocations.find(plan =>
    plan.recurring === true && planWeeks(plan) === String(weeks) && Number.isFinite(plan.price)
  ) || null;
  const route = suffix => `${String(data.root || '/').replace(/\/$/, '')}/${suffix}`;
  const menuDialog = document.getElementById('clc-cbd-menu');
  let restoreFocus;
  let frame;

  function setStatus(message) {
    $$('[data-status]').forEach(status => {
      status.textContent = message;
      status.hidden = !message;
    });
  }

  function updateCommerce() {
    const selectedVariant = variant();
    const selectedPlan = allocation();
    const options = ['4', '6', '8'].map(weeks => ({weeks, plan: allocation(weeks)}));

    $$('[data-mode]').forEach(card => {
      const selected = card.dataset.mode === state.mode;
      card.classList.toggle('on', selected);
      card.querySelector('.dot')?.classList.toggle('on', selected);
      const input = card.querySelector('input');
      if (input) {
        input.checked = selected;
        input.disabled = card.dataset.mode === 'once' && data.requiresSellingPlan;
      }
    });

    $$('.freq').forEach(select => {
      const current = select.value || state.weeks;
      select.replaceChildren(...options.map(({weeks, plan}) => {
        const option = new Option(plan ? `Delivered every ${weeks} weeks` : `Every ${weeks} weeks unavailable`, weeks);
        option.disabled = !plan;
        return option;
      }));
      select.value = options.some(item => item.weeks === current && item.plan) ? current : state.weeks;
      select.disabled = !options.some(item => item.plan);
    });
    $$('[data-freq]').forEach(wrapper => { wrapper.hidden = state.mode !== 'subscription'; });
    $$('[data-price-once]').forEach(node => { node.textContent = selectedVariant ? money(selectedVariant.price) : 'Unavailable'; });
    $$('[data-price-subscription]').forEach(node => { node.textContent = selectedPlan ? money(selectedPlan.price) : 'Unavailable'; });
    $$('[data-price-compare]').forEach(node => { node.textContent = selectedPlan ? money(selectedPlan.compareAtPrice) : ''; });
    const saving = selectedPlan?.compareAtPrice > 0 ? Math.round(100 * (1 - selectedPlan.price / selectedPlan.compareAtPrice)) : 0;
    $$('[data-saving]').forEach(node => { node.textContent = saving ? `SAVE ${saving}%` : 'SUBSCRIBE'; });
    $$('[data-saving-copy]').forEach(node => { node.textContent = saving ? `${saving}% off every order` : 'Recurring delivery'; });

    const blocked = !selectedVariant?.available ||
      (state.mode === 'subscription' && !selectedPlan) ||
      (state.mode === 'once' && data.requiresSellingPlan);
    $$('[data-add]').forEach(button => {
      button.disabled = blocked || state.busy || state.uncertain;
      button.setAttribute('aria-busy', String(state.busy));
      button.textContent = state.busy ? 'ADDING…' : 'ADD TO BAG';
    });

    if (!selectedVariant?.available) setStatus('This product is currently sold out.');
    else if (state.mode === 'subscription' && !selectedPlan) setStatus('Subscriptions are not configured for this delivery frequency yet.');
    else if (state.mode === 'once' && data.requiresSellingPlan) setStatus('This product requires a subscription.');
    else if (!state.uncertain) setStatus('');
  }

  function setupGallery(gallery) {
    const section = gallery.closest('[data-cbd-section="main"]');
    const slides = $$('[data-slide]', gallery);
    const thumbs = $$('[data-thumb]', section);
    let selected = 0;
    const render = () => {
      slides.forEach((slide, index) => { slide.style.display = index === selected ? 'block' : 'none'; });
      thumbs.forEach((thumb, index) => {
        thumb.classList.toggle('on', index === selected);
        thumb.setAttribute('aria-pressed', String(index === selected));
      });
    };
    thumbs.forEach((thumb, index) => {
      const choose = () => { selected = index; render(); };
      thumb.addEventListener('click', choose);
      thumb.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          choose();
        }
      });
    });
    render();
  }

  function setupTabGroup(group) {
    const buttons = $$('.tab-h', group);
    const setOpen = active => buttons.forEach((button, index) => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const open = index === active;
      button.setAttribute('aria-expanded', String(open));
      if (panel) panel.hidden = !open;
    });
    buttons.forEach((button, index) => button.addEventListener('click', () => {
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      setOpen(isOpen ? -1 : index);
      updateSticky();
    }));
    setOpen(0);
  }

  function setupGuidance(tablist) {
    const tabs = $$('button[role="tab"]', tablist);
    const container = tablist.parentElement;
    const panels = $$('[data-steps]', container);
    let selected = 0;
    const render = () => {
      tabs.forEach((tab, index) => {
        tab.setAttribute('aria-selected', String(index === selected));
        tab.tabIndex = index === selected ? 0 : -1;
      });
      panels.forEach((panel, index) => {
        panel.hidden = index !== selected;
        panel.style.display = index === selected ? 'grid' : 'none';
      });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => { selected = index; render(); });
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        selected = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        render();
        tabs[selected].focus();
      });
    });
    render();
  }

  function setupFaqGroup(group) {
    const buttons = $$('.faq-t', group);
    const setOpen = active => buttons.forEach((button, index) => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const open = index === active;
      button.setAttribute('aria-expanded', String(open));
      if (panel) panel.hidden = !open;
    });
    buttons.forEach((button, index) => button.addEventListener('click', () => {
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      setOpen(isOpen ? -1 : index);
      updateSticky();
    }));
    setOpen(-1);
  }

  function updateSticky() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const bar = document.querySelector('.clc-cbd-mobile [data-pagesmith-sticky]');
      const start = document.getElementById('m-sticky-start');
      if (!bar || !start) return;
      const mobile = !matchMedia('(min-width:1200px)').matches;
      const pastBuy = start.getBoundingClientRect().bottom < 0;
      const show = mobile && pastBuy;
      bar.classList.toggle('on', show);
      bar.setAttribute('aria-hidden', String(!show));
      bar.inert = !show;
      document.body.style.paddingBottom = show ? `${bar.getBoundingClientRect().height}px` : '';
    });
  }

  function showDialog(dialog, opener) {
    if (!dialog) return;
    restoreFocus = opener || document.activeElement;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    dialog.querySelector('[data-close]')?.focus();
  }

  [menuDialog].filter(Boolean).forEach(dialog => {
    dialog.querySelector('[data-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      document.body.style.overflow = '';
      if (restoreFocus?.isConnected) restoreFocus.focus();
    });
    dialog.addEventListener('click', event => {
      if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) dialog.close();
    });
  });

  async function request(suffix, options = {}) {
    const response = await fetch(route(suffix), {credentials: 'same-origin', cache: 'no-store', ...options});
    const result = await response.json();
    if (!response.ok) {
      const error = new Error(result.description || result.message || 'Your bag could not be updated. Please try again.');
      error.rejected = true;
      throw error;
    }
    return result;
  }

  function renderCart(cart) {
    const content = cartDialog?.querySelector('[data-cart-content]');
    if (!content) return;
    content.replaceChildren();
    if (!cart.items.length) {
      content.textContent = 'Your bag is empty.';
      return;
    }
    cart.items.forEach(item => {
      const line = document.createElement('article');
      line.className = 'cart-line';
      const values = [
        item.product_title || item.title,
        item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
        item.selling_plan_allocation?.selling_plan?.name || 'One-time purchase',
        `Quantity: ${item.quantity}`,
        money(item.final_line_price, cart.currency || data.currency)
      ];
      values.filter(Boolean).forEach(value => {
        const paragraph = document.createElement('p');
        paragraph.textContent = value;
        line.append(paragraph);
      });
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'cart-remove';
      remove.textContent = 'Remove';
      remove.addEventListener('click', async () => {
        remove.disabled = true;
        try {
          renderCart(await request('cart/change.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({id: item.key, quantity: 0})
          }));
        } catch (error) {
          setStatus(error.message);
          remove.disabled = false;
        }
      });
      line.append(remove);
      content.append(line);
    });
    const total = document.createElement('p');
    total.className = 'cart-total';
    total.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'} · Total ${money(cart.total_price, cart.currency || data.currency)}`;
    content.append(total);
  }

  async function openCart(opener) {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {detail: {opener}}));
  }

  async function addToCart(opener) {
    if (state.busy || state.uncertain || opener.disabled) return;
    const selectedVariant = variant();
    const selectedPlan = allocation();
    if (!selectedVariant?.available || (state.mode === 'subscription' && !selectedPlan)) return;
    const item = {id: selectedVariant.id, quantity: 1};
    if (state.mode === 'subscription') item.selling_plan = selectedPlan.id;
    state.busy = true;
    updateCommerce();
    let accepted = false;
    try {
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.().map(section => section.section) || [];
      const result = await request('cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items: [item], sections, sections_url: location.pathname})
      });
      accepted = true;
      if (drawer?.renderContents && sections.every(id => result.sections?.[id])) await drawer.renderContents(result, true);
      else {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {detail: {opener}}));
      }
    } catch (error) {
      state.uncertain = accepted || !error.rejected;
      setStatus(state.uncertain ? 'Your bag may have been updated. Open the bag to check before adding again.' : error.message);
    } finally {
      state.busy = false;
      updateCommerce();
    }
  }

  $$('[data-gallery]').forEach(setupGallery);
  $$('[data-tab-group]').forEach(setupTabGroup);
  $$('.seg[role="tablist"]').forEach(setupGuidance);
  $$('.faqs').forEach(setupFaqGroup);
  $$('[data-mode]').forEach(card => {
    card.addEventListener('click', event => {
      if (event.target.closest('select')) return;
      const input = card.querySelector('input');
      if (input?.disabled) return;
      state.mode = card.dataset.mode;
      updateCommerce();
    });
  });
  $$('.freq').forEach(select => select.addEventListener('change', event => {
    state.weeks = event.target.value;
    updateCommerce();
  }));
  $$('[data-add]').forEach(button => button.addEventListener('click', () => addToCart(button)));
  $$('[data-menu-open]').forEach(button => button.addEventListener('click', () => showDialog(menuDialog, button)));
  $$('[data-cart-open]').forEach(button => button.addEventListener('click', () => openCart(button)));
  window.addEventListener('scroll', updateSticky, {passive: true});
  window.addEventListener('resize', updateSticky, {passive: true});

  function renderStoredReviews() {
    document.querySelectorAll('[data-cbd-stored-reviews]').forEach(container => {
      const reviews = Array.from(container.querySelectorAll('.jdgm-rev')).map(review => ({
        id: review.dataset.reviewId,
        score: Math.max(0, Math.min(5, Number(review.querySelector('[data-score]')?.dataset.score || 0))),
        title: review.querySelector('.jdgm-rev__title')?.textContent.trim(),
        body: review.querySelector('.jdgm-rev__body')?.textContent.trim(),
        author: review.querySelector('.jdgm-rev__author')?.textContent.trim()
      })).filter(review => review.body);
      const output = document.createElement('div');
      output.dataset.reviewSource = 'shopify-stored-judgeme';
      let page = 0;
      const list = document.createElement('div');
      list.className = 'rvs';
      const render = () => {
        list.replaceChildren(...reviews.slice(page * 3, page * 3 + 3).map(review => {
          const article = document.createElement('article');
          article.className = 'rv'; article.dataset.reviewId = review.id;
          [['rv-st', '★'.repeat(review.score)], ['rv-q', review.title], ['rv-b', review.body], ['rv-a', review.author]].forEach(([cls, value]) => {
            const element = document.createElement('p'); element.className = cls; element.textContent = value || ''; article.append(element);
          });
          return article;
        }));
        previous.disabled = page === 0;
        next.disabled = (page + 1) * 3 >= reviews.length;
        status.textContent = `Page ${page + 1} of ${Math.ceil(reviews.length / 3)}`;
      };
      const pager = document.createElement('nav'); pager.className = 'clc-review-pager'; pager.setAttribute('aria-label', 'Customer review pages');
      const previous = document.createElement('button'); previous.type = 'button'; previous.textContent = 'Previous';
      const next = document.createElement('button'); next.type = 'button'; next.textContent = 'Next';
      const status = document.createElement('span'); status.setAttribute('aria-live', 'polite');
      previous.addEventListener('click', () => { page--; render(); });
      next.addEventListener('click', () => { page++; render(); });
      pager.append(previous, status, next); output.append(list, pager);
      if (reviews.length) { render(); container.replaceWith(output); }
    });
  }
  renderStoredReviews();

  updateCommerce();
  updateSticky();
})();
